import React from 'react'
import LandingPage from '/Users/manassingh/Desktop/tta-web/src/LandingPage.jsx'
import Footer from './Footer'

const Home = () => {
  return (
    <div>

        <LandingPage/>
        <Footer/>
    </div>
  )
}

export default Home